var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrintHome = function SvgPrintHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6338 21.7812C9.97631 21.7812 9.48315 21.2058 9.48315 20.5483C9.48315 19.8908 9.97631 19.3154 10.6338 19.3154C11.2914 19.3154 11.8667 19.8908 11.8667 20.5483C11.8667 21.2058 11.2914 21.7812 10.6338 21.7812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31885 38.6299C9.31885 38.6299 6.27775 38.6299 5.29144 38.6299C4.30514 38.6299 2.82568 37.808 2.82568 35.5066C2.82568 33.2053 2.82568 17.5888 2.82568 16.1093C2.82568 14.6299 3.89418 13.397 7.18186 13.397C8.00378 13.397 47.5381 13.397 48.6888 13.397C50.2505 13.397 51.5656 14.7942 51.5656 16.4381C51.5656 18.0819 51.5656 34.3559 51.5656 36.082C51.5656 37.808 50.3327 38.6299 48.8532 38.6299C47.3738 38.6299 45.1546 38.6299 45.1546 38.6299",
    stroke: "#05060B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8252 13.2331V0.904297H39.3184V13.3153",
    stroke: "#05060B",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.634 21.7812C11.3149 21.7812 11.8669 21.2292 11.8669 20.5483C11.8669 19.8674 11.3149 19.3154 10.634 19.3154C9.9531 19.3154 9.40112 19.8674 9.40112 20.5483C9.40112 21.2292 9.9531 21.7812 10.634 21.7812Z",
    fill: "#05060B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.634 21.7812C11.3149 21.7812 11.8669 21.2292 11.8669 20.5483C11.8669 19.8674 11.3149 19.3154 10.634 19.3154C9.9531 19.3154 9.40112 19.8674 9.40112 20.5483C9.40112 21.2292 9.9531 21.7812 10.634 21.7812Z",
    stroke: "#05060B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3049 29.7534H44.0859",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.894 29.9176V53.0958H14.5789V29.8354",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2366 38.2192H33.4832",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2366 44.7124H33.4832",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrintHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print-home.c447c35a.svg";
export { ForwardRef as ReactComponent };